<template>
    <template-form
        :listinghash="this.listinghash"
        context="listing"
        :validation="validation"
        :countries="data.countries"
        :inline="false"
        :useJobCode="true"
        @submit="udpateListing"
    ></template-form>
</template>
<script>
import TemplateForm from './TemplateForm.vue';
import CompanySearchMixins from './CompanySearchMixins.js';
export default {
    mixins: [CompanySearchMixins],
    props: {
        data: {
            type: Object,
            required: true,
        },
        listinghash: {
            type: String,
            required: true,
        },
    },
    created() {
        this.$store.commit(`${this.listinghash}/updateMustSelectFullRow`, true);
    },
    data() {
        return {
            validation: {
                search: [
                    { required: false },
                    { min: 2, message: window.i18n.__('2 caractères minimum') },
                ],
                district: [{ validator: this.districtValidator }],
                jobCode: {
                    required: false,
                },
            },
        };
    },
    methods: {
        udpateListing(payload) {
            let filters = [];

            Object.keys(payload.form).forEach((objectKey) => {
                filters.push({
                    data: payload.form[objectKey],
                    active: true,
                    name: objectKey,
                });
            });

            if (!payload.form.district && !payload.form.jobCode && !payload.form.search) {
                Push.error(
                    this.$l10n.__('Vous devez spécifier au moins un des champs de recherche'),
                );
                return;
            }

            this.$store.commit(`${this.listinghash}/updateCurrentPage`, 1);
            this.$store.commit(`${this.listinghash}/updateFilters`, filters);
            this.$store.commit(`${this.listinghash}/updateBatchData`, {
                countryCode: payload.form.countryCode,
                filters: filters,
            });
            this.$store.commit(`${this.listinghash}/deleteError`);

            this.$store.dispatch(`${this.listinghash}/fetch`).then(() => {
                this.$store.commit(`${this.listinghash}/updateFilters`, filters);

                //update column label depending countrycode
                let columns = this.$store.state[this.listinghash].columns;
                columns.map((column) => {
                    let label = window.CompanySearch.getLabelForCountry(
                        column.name,
                        payload.form.countryCode,
                    );
                    if (label !== '') {
                        column.label = label;
                    }

                    //set column jobCode rank at the last rank
                    if (column.name === 'companyJobCode') {
                        column.rank = columns.length - 1;
                    }

                    column.display = true;
                    return column;
                });

                //remove jobCode column for another provider that FR
                if (payload.form.countryCode !== 'FR') {
                    columns = columns.filter((column) => {
                        return column.name !== 'companyJobCode';
                    });
                }
                this.$store.commit(`${this.listinghash}/updateColumns`, columns);
                window.EventBus.emit('filters:apply');
            });
        },
    },
    components: {
        'template-form': TemplateForm,
    },
};
</script>
<style lang="sass">
.leftpane #companysearch-form {
    #search,input  {
        width: 100%;
    }
}
</style>
